require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-onsite-at-yarrabend.json") })
        }
      }, "path---news-onsite-at-yarrabend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-onsite-at-yarrabend!./.cache/json/news-onsite-at-yarrabend.json
// module id = 836
// module chunks = 231608221292675